import { Category, Product } from 'shared/types/product';

export const getProductParentCategory = (product: Product) => {
  const hasOneCategory = (product.categories?.length ?? 0) === 1;
  if (hasOneCategory) return product.categories?.[0];

  const categoriesWithDescendants: Category[] = [];
  const categoriesWithNoDescendants: Category[] = [];
  for (const category of product.categories ?? []) {
    if (!category.descendants?.length) categoriesWithNoDescendants.push(category);
    else categoriesWithDescendants.push(category);
  }

  if (categoriesWithNoDescendants?.length)
    return categoriesWithNoDescendants.reduce((acc, cat) => {
      if ((cat.orderHint ?? 0) > (acc.orderHint ?? 0)) return cat;
      return acc;
    });

  return categoriesWithDescendants.reduce((acc, cat) => {
    if ((cat.orderHint ?? 0) > (acc.orderHint ?? 0)) return cat;
    return acc;
  });
};
